export default "__VITE_ASSET__DOJxKyL9__"